<template>
  <BaseStepperDialog
    :dialogSettings="dialogSettings"
    :totalSteps="2"
    :isSaving="isSaving"
    @onStepsUpdate="handleStepUpdate"
    @onSave="handleSave"
    @onClose="handleClose"
  >
    <template v-slot>
      <div class="dialog__form container col-lg-6 col-sm-12 mt-6">
        <div v-show="currentStep === 1">
          <h2>Which of these documents do you have to hand?</h2>
          <RadioButton
            @select="handleRadioChange"
            :selected-value="idType"
            :options="options"
            withSublabel
          />
        </div>
        <div v-show="currentStep === 2">
          <h2>Upload a photo of your {{ idType }}</h2>
          <!-- WIP will update component when api is available -->
          <UploadDocument :compliance="compliance" />
        </div>
      </div>
    </template>
  </BaseStepperDialog>
</template>

<script>
import BaseStepperDialog from "@/components/common/BaseStepperDialog";
import RadioButton from "@/components/common/RadioButton";
import { PROOF_OF_ID_TYPES } from "@/constants/offers";
import UploadDocument from "@/views/offers/components/compliances/forms/UploadDocument";

export default {
  props: {
    dialogSettings: Object,
    compliance: Object
  },
  components: { BaseStepperDialog, RadioButton, UploadDocument },
  data() {
    return {
      currentStep: 1,
      options: PROOF_OF_ID_TYPES,
      isSaving: false,
      idType: null
    };
  },
  methods: {
    handleRadioChange(selectedValue) {
      this.idType = selectedValue;
    },
    handleStepUpdate(currentStep) {
      this.currentStep = currentStep;
    },
    handleSave() {
      // WIP
      this.isSaving = true;
    },
    handleClose() {
      this.isSaving = false;
      this.currentStep = 1;
    }
  }
};
</script>
